import Icon from 'veui/components/Icon'

Icon.register({
  'file-approve': {
    paths: [
      {
        d: 'M256 192a32 32 0 000 64h256a32 32 0 000-64zm97 480H160V96h448v224a32 32 0 0064 0V64a32 32 0 00-32-32H128a32 32 0 00-32 32v640a32 32 0 0032 32h225a32 32 0 000-64zm-97-320a32 32 0 000 64h160a32 32 0 000-64zm357.39 290.7L608 640v-37.49a96.15 96.15 0 0064-93c-1.27-50.35-41.84-91.5-92.17-93.46A96 96 0 00544 602.51V640l-5.39 2.7c-23.23 11.61-47.15 21.7-71.07 31.81A32 32 0 00448 704a32 32 0 0032 32h192a32 32 0 0032-32 32 32 0 00-19.54-29.49c-23.92-10.11-47.84-20.2-71.07-31.81zM576 480a32 32 0 11-32 32 32 32 0 0132-32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
